import { createAuthClient } from 'better-auth/react';

/**
 * Better Auth browser client.
 *
 * No baseURL on purpose: the client calls /api/auth/* on whatever origin the
 * page is served from, so the same build works on localhost, Netlify deploy
 * previews and the production domain.
 */
const client = createAuthClient();

export interface SessionUser {
  id: string;
  email: string;
  name?: string | null;
  image?: string | null;
  createdAt?: string | Date;
  emailVerified?: boolean;
}

export interface AppSession {
  user: SessionUser;
  session: { id: string; expiresAt: string | Date };
}

export interface UseSessionResult {
  data: AppSession | null;
  isPending: boolean;
  error?: unknown;
  refetch?: () => void;
}

/**
 * The library infers the session shape from the *server* config, which lives in
 * a different tsconfig project here — so without this annotation `data` widens
 * to `never` and every `session.user` read fails to type-check. The shape below
 * is what Better Auth actually returns for this app's configuration.
 */
export const authClient = client as Omit<typeof client, 'useSession'> & {
  useSession: () => UseSessionResult;
};

export const { signIn, signUp, signOut } = client;
export const useSession = authClient.useSession;
